// extracted by mini-css-extract-plugin
module.exports = {"Job":"Job_Job__0MFcQ","spinner":"Job_spinner__urnHn"};